
define('app/auth/authApp',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/loginModel',
	'unknown/views/loginView'
], function($, _, Backbone, LoginModel, LoginView){
	var initialize = function(){
		var loginModel = new LoginModel();
		var loginView = new LoginView({loginModel: loginModel});
		loginView.render();
	};
	
	return {
		initialize: initialize
	};
});